
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

import { use } from './lib/extension';
export * from './lib/export/core';
import { install as CanvasRenderer } from './lib/renderer/installCanvasRenderer';
import { install as LineChart } from './lib/chart/line/install';
import { install as BarChart } from './lib/chart/bar/install';
import { install as PieChart } from './lib/chart/pie/install';
import { install as GridSimpleComponent } from './lib/component/grid/installSimple';
import { install as AriaComponent } from './lib/component/aria/install';
import { install as DatasetComponent } from './lib/component/dataset/install';
use([CanvasRenderer]);
use([LineChart, BarChart, PieChart]);
use([GridSimpleComponent, AriaComponent, DatasetComponent]);